import { Button } from "@/components/ui/button";

const DCPromoBanner = () => {
  const scrollToForm = () => {
    const formElement = document.getElementById("lead-form");
    if (formElement) {
      window.dispatchEvent(new Event("force-load-form"));
      formElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="w-full bg-primary">
      <div className="container mx-auto px-4 py-3 sm:py-3.5">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-5">
          <p className="text-sm sm:text-[0.95rem] font-semibold leading-relaxed text-center text-primary-foreground">
            Launch Offer for Washington DC &amp; Manassas homes: First 3 months
            at 10% + free professional photos + free listing audit and
            optimization. Limited to our first 10 homes.
          </p>
          <Button
            onClick={scrollToForm}
            size="sm"
            className="bg-primary-foreground text-primary hover:bg-primary-foreground/90 font-bold rounded-full whitespace-nowrap shrink-0 h-9 px-5 text-sm"
          >
            Claim Your Spot
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DCPromoBanner;
